import React from "react";
import { View } from "react-native";
import { IconButton, Surface, Text } from "react-native-paper";
import { formatWeekRange, isCurrentWeek } from "../utils/weekUtils";

type Props = {
  weekDates: Date[];
  onPrevious: () => void;
  onNext: () => void;
  locale?: string;
  currentWeekLabel?: string;
};

export default function WeekNavigator({
  weekDates,
  onPrevious,
  onNext,
  locale = "ru-RU",
  currentWeekLabel = "Текущая неделя",
}: Props) {
  return (
    <Surface
      style={{
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: 8,
      }}
      elevation={1}
    >
      <IconButton icon="chevron-left" size={24} onPress={onPrevious} />
      <View style={{ alignItems: "center" }}>
        <Text variant="titleMedium">{formatWeekRange(weekDates, locale)}</Text>
        {isCurrentWeek(weekDates) && (
          <Text variant="labelSmall" style={{ opacity: 0.7 }}>
            {currentWeekLabel}
          </Text>
        )}
      </View>
      <IconButton icon="chevron-right" size={24} onPress={onNext} />
    </Surface>
  );
}
